export const encode = (text: string) => {
    const div = document.createElement('div');
    div.innerText = text;

    return div.innerHTML;
};

export const decode = (html: string) => {
    const div = document.createElement('div');

    //tslint:disable-next-line:no-inner-html
    div.innerHTML = html;

    return div.childNodes.length > 0 ? div.innerText : '';
};
